import React, { useState } from 'react';
import moment from 'moment';
import { FormInputSelect } from '../../../../common/formInputsV2/FormInputSelect';
import { gsccontratto_1_11 } from '../../../../utils/globalCasaConstants';
import { FormInputRadio } from '../../../../common/formInputsV2/FormInputRadio';
import { genders } from '../../../../common/constants';
import { FormInputText } from '../../../../common/formInputsV2/FormInputText';
import FormReactSelectInputBirthPlace from '../../../../common/formInputsV2/FormReactSelectInputBirthPlace';
import { FormInputDate } from '../../../../common/formInputsV2/FormInputDate';
import { FormInputAddressCompleteManual } from '../../../../common/formInputsV2/FormInputAddressCompleteManual';
import { FormInputAddressComplete } from '../../../../common/formInputsV2/FormInputAddressComplete';
import { FormLayout } from '../../../../common/formInputsV2/FormLayout.styles';
import getMinAllowedBirthday from '../../../../common/helpers/getMinAllowedBirthday';

function DatiContrattualiStep({
  register,
  errors,
  isValid,
  formDataFlow,
  updateFormData,
  formData,
  states,
  municipalities,
}) {
  const [showManualAdress, setShowManualAdress] = useState(false);

  return (
    <FormLayout>
      <FormInputSelect
        label={gsccontratto_1_11.desc_campo}
        options={gsccontratto_1_11.options.map((option) => ({
          id: option.valore,
          name: option.label,
        }))}
        registration={register('insurance_formula')}
        placeholder="Seleziona formula assicurata"
        error={errors.insurance_formula?.message}
        valid={isValid('insurance_formula')}
      />
      {formDataFlow.insurance_formula !== '' && (
        <>

          <FormInputRadio
            options={genders}
            label="Il contraente è"
            name="gender"
            registration={register('gender')}
            error={errors.gender?.message}
          />

          <div>
            {formDataFlow.gender === 'G' ? (
              <div>
                <FormInputText
                  placeholder="Ragione Sociale"
                  label="Ragione Sociale"
                  registration={register('business_name')}
                  error={errors.business_name?.message}
                  valid={isValid('business_name')}
                />
                <FormInputText
                  placeholder="Partita Iva"
                  label="Partita Iva"
                  registration={register('vat_number')}
                  error={errors.vat_number?.message}
                  valid={isValid('vat_number')}
                />
                <FormInputSelect
                  label="Tipologia azienda"
                  registration={register('company_type')}
                  error={errors.company_type?.message}
                  valid={isValid('company_type')}
                  placeholder="-Seleziona-"
                  options={formData.company_types}
                />
              </div>
            ) : (
              <div>
                <FormInputText
                  placeholder="Nome"
                  label="Nome"
                  registration={register('name')}
                  error={errors.name?.message}
                  valid={isValid('name')}
                />
                <FormInputText
                  placeholder="Cognome"
                  label="Cognome"
                  registration={register('surname')}
                  error={errors.surname?.message}
                  valid={isValid('surname')}
                />
                <FormInputDate
                  label="Data di nascita"
                  registration={register('date_of_birth')}
                  minDate={getMinAllowedBirthday()}
                  maxDate="2021-01-01"
                  error={errors.date_of_birth?.message}
                  valid={isValid('date_of_birth')}
                />
                <FormReactSelectInputBirthPlace
                  states={states}
                  options={municipalities}
                  label="Luogo di nascita"
                  name="commune_of_birth_code"
                  values={{
                    commune_of_birth_code: formDataFlow.commune_of_birth_code,
                    province_of_birth_code: formDataFlow.province_of_birth_code,
                    born_abroad: formDataFlow.born_abroad,
                    country_of_birth_code: formDataFlow.country_of_birth_code,
                  }}
                  onChange={(value) => updateFormData({
                    commune_of_birth_code: value.commune_of_birth_code,
                    province_of_birth_code: value.province_of_birth_code,
                    born_abroad: value.born_abroad,
                    country_of_birth_code: value.country_of_birth_code,
                  })}
                  valid={isValid('commune_of_birth_code')}
                  error={errors.commune_of_birth_code?.message}
                  valid_country_of_birth_code={isValid('country_of_birth_code')}
                  error_country_of_birth_code={errors.country_of_birth_code?.message}
                />
              </div>
            )}

          </div>
          <FormInputText
            registration={register('email')}
            label="E-mail"
            placeholder="nome@esempio.it"
            error={errors.email?.message}
            valid={isValid('email')}
          />
          <FormInputText
            registration={register('phone')}
            label="Phone"
            placeholder="Es. 3401234567"
            paragraph="Numeri di rete fissa non accettati dalle aziende"
            error={errors.phone?.message}
            valid={isValid('phone')}
          />
          {showManualAdress ? (
            <FormInputAddressCompleteManual
              municipalities={municipalities}
              formData={formDataFlow}
              isValid={isValid}
              errors={errors}
              register={register}
              updateFormData={updateFormData}
            />
          ) : (
            <FormInputAddressComplete
              municipalities={municipalities}
              formData={formDataFlow}
              isValid={isValid}
              errors={errors}
              register={register}
              updateFormData={updateFormData}
              addressId="autocomplete-address-contractor"
              setShow={setShowManualAdress}
            />
          )}

          <FormInputDate
            label="Data Decorrenza"
            registration={register('policy_effective_date')}
            minDate={moment().add(7, 'days').format('YYYY-MM-DD')}
            error={errors.policy_effective_date?.message}
            valid={isValid('policy_effective_date')}
          />
        </>
      )}
    </FormLayout>
  );
}

export default DatiContrattualiStep;
